// ID generation service
import { nanoid } from 'nanoid';

export function shortid() {
  return nanoid(10);
}

